import { useMemo } from 'react';
import moment from 'moment';
import get from 'lodash/get';
import filter from 'lodash/filter';
import reverse from 'lodash/reverse';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import parseInt from 'lodash/parseInt';
import sortBy from 'lodash/sortBy';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';

function useGetEvents(data = []) {
  const today = moment().format('YYYY-MM-DD');

  const eventsSortedByDate = useMemo(() => {
    const eventStartDate = (date) => new Date(moment(date, 'YYYY-MM-DD HH:mm').format()).getTime();

    return [...data].sort((a, b) => (
      eventStartDate(`${ get(a, 'eventStartDate') } ${ get(a, 'eventStartTime') || '00:00' }`)
      - eventStartDate(`${ get(b, 'eventStartDate') } ${ get(b, 'eventStartTime') || '00:00' }`)
    ));
  }, [data]);

  const years = useMemo(() => {
    const allYears = uniq(map(eventsSortedByDate, (event) => (
      parseInt(moment(event.eventStartDate).format('YYYY'))
    )));

    const expandedYears = [];
    forEach(allYears, (year) => {
      expandedYears.push(year);
      expandedYears.push(year + 1);
      expandedYears.push(year - 1);
    });

    return sortBy(uniq(expandedYears));
  }, [eventsSortedByDate]);

  const seasonsEvents = useMemo(() => (
    filter(
      map(years, (year) => {
        const seasonStart = moment(`${ year }-08-01`, 'YYYY-MM-DD');
        const seasonEnd = moment(`${ year + 1 }-07-31`, 'YYYY-MM-DD');

        return {
          season: `${ year } / ${ year + 1 }`,
          events: filter(eventsSortedByDate, (event) => (
            moment(event.eventStartDate, 'YYYY-MM-DD')
              .isBetween(seasonStart, seasonEnd, 'day', '[]')
          )),
        };
      }),
      (e) => !isEmpty(e.events),
    )
  ), [eventsSortedByDate, years]);

  const pastEvents = useMemo(() => (
    reverse(
      filter(eventsSortedByDate, (event) => (
        moment(today, 'YYYY-MM-DD')
          .isAfter(moment(event.eventStartDate, 'YYYY-MM-DD'), 'day')
      )),
    )
  ), [eventsSortedByDate, today]);

  const incomingEvents = useMemo(() => (
    filter(eventsSortedByDate, (event) => (
      moment(today, 'YYYY-MM-DD')
        .isBefore(moment(event.eventStartDate, 'YYYY-MM-DD'), 'day')
    ))
  ), [eventsSortedByDate, today]);

  return {
    pastEvents,
    incomingEvents,
    seasonsEvents,
  };
}

export default useGetEvents;
